// extracted by mini-css-extract-plugin
export default {"playerContainer":"VideoPlayer_playerContainer__H3TtY","fullScreen":"VideoPlayer_fullScreen__vyF2V","playIconOverlay":"VideoPlayer_playIconOverlay__sQJy0"};